import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { axiosInstance } from "../App";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Extract token from URL
  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Basic validation
    if (!password || !confirmPassword) {
      setError("Both fields are required.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      // Replace with your backend API endpoint
      const response = await axiosInstance.post(process.env.REACT_APP_API_HOST_TEST+"password-reset/confirm",  {"token":token, "password":password}, {
        headers: {
          "Content-Type": "application/json",
//           "Accept-Language": i18n.language, // Add current language
        }});

      if (response.status === 200) {
        setSuccess(true);
        setTimeout(() => navigate("/login"), 3000); // Redirect to login after success
      } else {
        setError("Failed to reset password. Make sure you used the right link. If you continue having issues, please contact the support team");
      }
    } catch (err: any) {
      setError(err.response?.data?.message || "Failed to reset password. Make sure you used the right link. If you continue having issues, please contact the support team.");
    }
  };

  return (
    <div style={{ maxWidth: "400px", margin: "50px auto", textAlign: "center" }}>
      <h2>Reset Password</h2>
      {success ? (
        <p>Password reset successfully! Redirecting to login...</p>
      ) : (
        <>
          {error && <p style={{ color: "red" }}>{error}</p>}
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "15px" }}>
              <label>
                New Password
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ width: "100%", padding: "8px", margin: "5px 0" }}
                  required
                />
              </label>
            </div>
            <div style={{ marginBottom: "15px" }}>
              <label>
                Confirm Password
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  style={{ width: "100%", padding: "8px", margin: "5px 0" }}
                  required
                />
              </label>
            </div>
            <button
              type="submit"
              style={{
                padding: "10px 20px",
                backgroundColor: "#007BFF",
                color: "#fff",
                border: "none",
                cursor: "pointer",
              }}
            >
              Reset Password
            </button>
          </form>
        </>
      )}
    </div>
  );
};

export default ResetPassword;
